import LayoutCenter from "@/components/LayoutCenter";
import LogoWithTextCentered from "@/components/LogoWithTextCentered";
import { buttonVariants } from "@/components/ui/button";
import { PageProps } from "@/types/PageProps";
import { ArrowRightIcon } from "lucide-react";

type PageData = PageProps & {
  error: string;
  notice: string;
};

export default function Root({ user }: PageData) {
  return (
    <LayoutCenter>
      <LogoWithTextCentered className="h-12 w-auto fill-foreground my-1 mb-8" />

      {user ? (
        <a href="/dashboard" className={buttonVariants({ size: "lg" })}>
          Go to your dashboard <ArrowRightIcon className="w-4 h-4" />
        </a>
      ) : (
        <div className="flex flex-col gap-4">
          <a href="/register" className={buttonVariants({ size: "lg" })}>
            Sign up
          </a>
          <a href="/session/new" className={buttonVariants({ variant: "outline", size: "lg" })}>
            Sign in
          </a>
        </div>
      )}
    </LayoutCenter>
  );
}
